import { IntlContext, TranslatorContext, useTranslator } from '@jutro/locale';
import { Loader, useModal } from '@jutro/components';
import {
    useDataRefresh,
    ViewModelForm,
    ViewModelServiceContext,
} from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import _, { isUndefined } from 'lodash';
import React, {
    useContext,
    useEffect,
    useState,
    useCallback
} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { AgencyAdminService } from '../../../../capabilities/twia-capability-agencyadmin';
import styles from '../AddUser/AddUser.module.scss'
import metadata from './AddUser.metadata.json5';
import messages from './AddUser.messages.js'; //DE15326

import { Button, CheckboxField } from '@jutro/legacy/components';

function AddUser(props) {
    const { onValidate, isComponentValid } =
        useValidation('AddUser');
    const { refreshData } = useDataRefresh();
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [userVM, setUserVM] = useState({});
    const [showAddLabel, setShowAddLabel] = useState(false);
    const [showInfoLabel, setShowInfoLabel] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    const [userRoles, setUserRoles] = useState([]);
    const [countUser, setCountUser] = useState(false);
    const [selectUser, setSelectUser] = useState(false);
    const [orgsUser, setOrgsUser] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    const translator = useContext(TranslatorContext);
    const { showAlert } = useModal();
    const {
        groupPublicID,
        history,
        id,
        usersData,
        isMasterGroup,
        associationName_TWIA
    } = props;

    const { authHeader } = useAuthentication();
    const [buttonVisible, setButtonVisibile] = useState(false);
    const [roleVisible, setRoleVisibile] = useState(false);
    const [selectExistUserVisible, setSelectExistUserVisibile] = useState(false);
    const [visibility, setVisibility] = useState(false);
    const [agencyID, setAgencyID] = useState();
    const [emailValidationMessage, setEmailValidationMessage] = useState([]); //DE15326
    const isPhoneNumberValid = (phone) => /^[2-9]\(?([0-9]{2})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/.test(phone);
    const [phoneValidationMessage, setPhoneValidationMessage] = useState([]);

    const ACTION_MSG = { //DE15326 To show the validation message for roles
        cancelAction: {
            title: translator(messages.RoleValidationTitle),
            message: translator(messages.RoleValidationMessage),
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: translator(messages.RoleButtonCloseMessage),
        }
    };

    useEffect(() => {
        // Done code fixes for tfpa
        let path = '';

        if (associationName_TWIA === 'twia') {
            path = 'org.twia.elevate.edge.capabilities.agent.dto.UserDTO'

        } else {
            path = 'org.tfpa.edge.capabilities.agent.dto.UserDTO'
        }

        const user = viewModelService?.create(
            {},
            'pc',
            path
        )

        setUserVM(user);
    }, [viewModelService]);

    // DE19170
    const setUserDetailsVisibility = useCallback(()=> {
        setSelectExistUserVisibile(true);
        setRoleVisibile(false);
        setVisibility(false);
        setCountUser(false);
    }, []);

    const setNewUserVisibility = useCallback(() => {
        setShowInfoLabel(true);
        setShowAddLabel(true);
        setUserVM(userVM);
        setOrgsUser(undefined);
        setCountUser(true);
        setVisibility(true);
        setSelectExistUserVisibile(false);
        setRoleVisibile(true);
        setButtonVisibile(true);
    }, [userVM])

    const validateUserEmailAssociation = (searchUsersPromise) => {
        return searchUsersPromise.then((res) => {
            const associationMatched = (res.orgUsers || []).some(
                orgUser => orgUser.associationName_TWIA === associationName_TWIA
            );
    
            if (associationMatched) {
                showAlert({
                    title: translator(messages.UserExistsTitle),
                    message: translator(messages.UserExistsMessage, { associationName: associationName_TWIA.toUpperCase() }),
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: translator(messages.RoleButtonCloseMessage)
                });
                return false;
            }
            return true;
        }, (err) => {
            console.error('Error loading user info request', err);
            return false;
        });
    };

    const onSearch = () => {
        let response;
        let searchUsersPromise;
        let userRolesPromise;
        const isUserExist = usersData.some(obj => obj.email === userVM.email.value);
        const agencyId = isUserExist ? null : groupPublicID
        const groupRoleParam = isMasterGroup !== true //DE15326

        setAgencyID(agencyId);
        setIsLoadingData(true);
        // Added tfpa related calls
        if (associationName_TWIA === 'twia') {
            searchUsersPromise = AgencyAdminService.countUsersWithEmail(userVM.email.value, groupPublicID, authHeader).then((res) => {
                response = res;

            }, (err) => {
                console.error('Error loading Group info request', err);
            });

            userRolesPromise = AgencyAdminService.getUserWithRoles(groupRoleParam, authHeader).then((roles) => {
                userVM.value.userRoles = roles.userRoles
            }, (err) => {
                console.error('Error loading Group info request', err);
            });

        } else {
            searchUsersPromise = AgencyAdminService.countUsersWithEmail_tfpa(userVM.email.value, authHeader).then((res) => {
                response = res;

            }, (err) => {
                console.error('Error loading Group info request', err);
            });

            userRolesPromise = AgencyAdminService.getUserWithRoles_tfpa(groupRoleParam, authHeader).then((roles) => {
                userVM.value.userRoles = roles.userRoles
            }, (err) => {
                console.error('Error loading Group info request', err);
            });

        }


        Promise.all([searchUsersPromise, userRolesPromise]).then(() => {
            setIsLoadingData(false);

            if (response === 0) {
                setNewUserVisibility()
            } else {
                if (associationName_TWIA === 'twia') {
                    AgencyAdminService.searchUsersInOrgByEmail(userVM.email.value, groupPublicID, authHeader).then((matchingUsersResponse) => {
                        // User already exists in current organization
                        if (matchingUsersResponse.orgUsers?.length > 0) {
                            setUserRoles(matchingUsersResponse.orgUsers);
                            setOrgsUser(matchingUsersResponse.orgUsers);
                            setUserDetailsVisibility() // DE19170
                            return;
                        }
                        // User doesn't exist in current organization.
                        // Check other organizations.
                        const searchUsersPromise = AgencyAdminService.searchUsersByEmailNotInOrg(
                            userVM.email.value,
                            groupPublicID,
                            authHeader
                        )
                        validateUserEmailAssociation(searchUsersPromise);
                    });
                } else {
                    AgencyAdminService.searchUsersInOrgByEmail_tfpa(userVM.email.value, authHeader).then((matchingUsersResponse) => {
                        setUserRoles(matchingUsersResponse.orgUsers);
                        setOrgsUser(matchingUsersResponse.orgUsers);
                        // DE19170
                        if (matchingUsersResponse.orgUsers?.length > 0) {
                            setUserDetailsVisibility();
                            return;
                        }
                        const searchUsersPromise = AgencyAdminService.searchUsersByEmailNotInOrg_tfpa(
                            userVM.email.value,
                            authHeader
                        );
                        validateUserEmailAssociation(searchUsersPromise).then((isValid) => {
                            if (isValid) {
                                setNewUserVisibility();
                            }
                        });
                    });
                }
            }
        })
    };

    const submit = useCallback(() => {
        // onSubmit(userVM.value); 
        // eslint-disable-next-line array-callback-return
        let roleSelected = false;

        if (!isComponentValid) {
            setShowErrors(true);

            return false
        }

        userVM.value.userRoles.map((role) => {
            if (role.isApplicable) {
                roleSelected = true;
            }
        });

        if (roleSelected) {
            if (countUser) {
                if (associationName_TWIA === 'twia') {
                    // DE15437
                    AgencyAdminService.addUser(userVM.value, groupPublicID, authHeader).then((res) => {
                        history.go('/administration');
                    }, (err) => {

                    });
                } else {
                    AgencyAdminService.addUser_tfpa(userVM.value, groupPublicID, authHeader).then((res) => {
                        history.go('/administration');
                    }, (err) => {

                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-empty-function

            }
            else {
                // eslint-disable-next-line security/detect-object-injection, @typescript-eslint/no-empty-function
                if (associationName_TWIA === 'twia') {
                    // DE15437
                    AgencyAdminService.addUserToGroup(orgsUser[selectUser].publicID, groupPublicID, authHeader).then((res) => {
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        history.go('/administration');
                    }, (err) => {

                    });
                } else {

                    AgencyAdminService.addUserToGroup_tfpa(orgsUser[selectUser].publicID, groupPublicID, authHeader).then((res) => {
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        history.go('/administration');
                    }, (err) => {

                    });
                }

            }

        } else {
            const message = ACTION_MSG.cancelAction;

            showAlert(message).then(results => {

            })

        }
    }, [selectUser, orgsUser, agencyID, isComponentValid]);

    const cancel = useCallback(() => {
        history.go('/administration');
    })

    const handleClick = useCallback(
        (value, path, index) => {
            _.set(userVM.userRoles.value[index], 'isApplicable', value);
            setUserVM(userVM);
            refreshData();
        },
        [userVM, refreshData]
    );

    const getCheckBox = useCallback(
        (item, index) => {
            return (
                <CheckboxField
                    name={item.name}
                    id={item.name}
                    value={item.isApplicable}
                    onValueChange={e => handleClick(e, item, index)}
                />
            );
        },
        [handleClick]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getUserSelected = useCallback((item, index) => {
        setSelectUser(index);

        if (!countUser) {
            // eslint-disable-next-line security/detect-object-injection
            userVM.value.userRoles = userRoles[index]?.userRoles
        }

        return (
            <Button

                onClick={() => { setButtonVisibile(true); setRoleVisibile(true); }}
            // eslint-disable-next-line react/jsx-no-literals
            >
                Select
            </Button>
        );
    });

    const getCell = useCallback(
        (item, index, property) => {
            if (property.id === "isEFTEnabled") {
                return (
                    <span >
                        {item[property.id] ? "Yes" : "No"}
                    </span>
                );
            }

            if (property.id === "status") {
                return (
                    <span >
                        {item[property.id] ? "Active" : "Inactive"}
                    </span>
                );
            }

            return (
                <span >
                    {item[property.id]}
                </span>
            );
        },
        []
    );
    // DE15379
    const existUserHeader = () => {
        if (isMasterGroup) {
            return translator(messages.existUserOrgAdmin)
        }

        return translator(messages.existUserAgencyAdmin)
    }

    // DE15407
    const tableRolesData = useCallback(() => {
        if (userVM.userRoles) {
            if (countUser) {
                return userVM?.userRoles?.value
            }

            return userVM?.userRoles?.value?.filter(role => role.isApplicable)
        }

        return []

    }, [countUser, userVM])

    useCallback(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidate]);


    const validatePhoneNumber = useCallback(
        (value) => {

            if (value.length === 3 || value.length === 7) {
                value += "-"
            }

            setPhoneValidationMessage([]);

            if (!isPhoneNumberValid(value) || value.match(/[0-9]/g).length < 10) {

                setPhoneValidationMessage([translator(messages.PhoneValidationMessage)])
            }

        },
        [translator]);

    const writeValue = useCallback(
        (value, path) => {
            _.set(userVM, `${path}.value`, value);

            if (!userVM.email.aspects.valid) {
                setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            }

            setUserVM(userVM);

            if (path === 'email') {
                setVisibility(false);
                setButtonVisibile(false);
                setRoleVisibile(false);
                setSelectExistUserVisibile(false);
            }

            if (path === 'phoneNumber' && !_.isEmpty(userVM.phoneNumber.value)) {
                validatePhoneNumber(value)
            }
            else {
                setPhoneValidationMessage([translator(messages.PhoneValidationRequiredMessage)])
            }

            refreshData();
        },
        [userVM, refreshData, translator, validatePhoneNumber]
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        // DE15411
        '@field': {
            labelPosition: 'left',
            showErrors,
            phoneWide: {
                labelPosition: 'top',
            },
        },
        newUserDiv: {
            visible: visibility
        },
        searchButton: {
            disabled: !userVM?.email?.aspects?.subtreeValid,
            className: styles.buttonAddUserDetail
        },
        newEmailAddress: {
            readOnly: false,
            validationMessages: userVM?.email?.aspects?.valid ? [] : emailValidationMessage
        },
        noUserFound: {
            visible: countUser
        },
        userRolesTable: {
            data: tableRolesData(),
            visible: roleVisible
        },
        checkbox: {
            visible: countUser // Reverted changes for checkboxes of Existing user
        },
        userRolesTableHeader: {
            visible: roleVisible
        },
        tableExistingUserDetails: {
            visible: selectExistUserVisible,
            data: orgsUser
        },
        selectUserHeader: {
            visible: selectExistUserVisible,
            content: existUserHeader() // DE15379 Changed the header based on Org Administrator/Agency Screen
        },
        buttonGroup: {
            visible: buttonVisible
        },

        eftEnabled: {
            visible: associationName_TWIA !== 'tfpa' // No need to show this column for tfpa
        },
        phoneNumber: {
            validationMessages: userVM?.phoneNumber?.aspects.valid ? [] : phoneValidationMessage
        }
    };

    const readValue = useCallback(
        (id, path) => {
            return readViewModelValue(
                metadata.pageContent,
                userVM,
                id,
                path,
                overrideProps
            );
        },
        [userVM, overrideProps]
    );

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {

        },
        resolveCallbackMap: {
            //clickCancel:onCancel,
            onSearch: onSearch,
            clickSubmit: submit,
            getCheckBox: getCheckBox,
            getUserSelected,
            getCell,
            clickCancel: cancel
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={userVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValueChange={writeValue}
            onValidationChange={onValidate}
        />
    );
}

AddUser.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

AddUser.defaultProps = {

};

export default withAuthenticationContext(withRouter(AddUser));
